import type ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { Observable, map } from "rxjs";
import { create } from "superstruct";
import { inject, singleton } from "tsyringe";

import { rewardsAuthApiClientToken } from "../../../tokens";
import type { EarnPointsEntity } from "../models/RewardsEarnPointsEntity";
import { EarnPointsSchema } from "../models/RewardsEarnPointsSchema";

@singleton()
class RewardsEarnPointsApiService {
    constructor(
        @inject(rewardsAuthApiClientToken)
        private readonly apiClient: ApiClientInterface
    ) {}

    getAmountForProduct(productId: number): Observable<EarnPointsEntity> {
        return this.apiClient
            .get({
                url: "/points/getAmountForProduct",
                responseType: "json",
                queryParams: { productId },
            })
            .pipe(map((response) => create(response.body, EarnPointsSchema)));
    }
}

export default RewardsEarnPointsApiService;
